import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import "./remiandPassword.css"
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CustomInput from '../../../components/Elements/input/customInput';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import axios from 'axios';
import { API_URL } from '../../../config';
import { useSelector } from 'react-redux';
import CustomRedText from '../../../components/Elements/redText/redText';

const RemiandPassword = (props) => {
    const history = useHistory();
    const userPasswordForgetURL = `${API_URL}UserPasswordForget`;
    const key = useSelector((state) => state.repos.chName);
    const [msg, setMsg] = useState("");

    const [formData, setFromData] = useState({
        login: '',
        currentPurchaseKey: key
    });
    const closeModal = ()=>{
        if(props.modalState.split(" ").length == 1){
            if(msg!=""){
        props.closeModal()
        setMsg('');
        setFromData({...formData, ...{ login: '' },})
    }}
    }
    useEffect(()=>{
        setMsg('');
        setFromData({...formData, ...{ login: '' },})
        if(document.getElementsByClassName('remiandPassword_area')[0] != undefined){
        document.getElementsByClassName('remiandPassword_area')[0].addEventListener('keypress', function (e) {     
            if (e.key === 'Enter') {
                save(e);
            }
        });}
    }
    ,[])
   
    function reset(){
        setFromData({...formData, ...{ login: '' },})
        setMsg('');
    }
    const save = (e) => {
        e.preventDefault();
      
        localStorage.setItem('odzyskajLogin', formData.login);
        axios
            .post(userPasswordForgetURL, formData)
            .then((response) => {
                if (response.data.succeeded == 1) {
                    setMsg('odzyskaj_konto_wyslane');
                    setTimeout(closeModal, 3000)
                }
               
            })
            .catch(function (error) {
                if (
                    error.response.data.message == 'Nie znaleziono użytkownika / nieaktywne konto.'
                ) {
                    setMsg('error_unactive_user');
                    setTimeout(closeModal, 3000)
                } else if (error.response.data.message == 'Błąd podczas przypomnienia hasła.') {
                    setMsg('error_przypominanie_hasla');
                    setTimeout(closeModal, 3000)
                }
            });
    };
 
    return <>   
          {
    msg == "error_unactive_user"?
    <div className='remiandPasswordSuccessMsg_area'>
    <CustomRedText>Wystąpił problem</CustomRedText>
    <div className='msg_area'>
    <p className='msg msgIn'>Na podany adres e-mail nie założono jeszcze konta. Spróbuj założyć konto jeszcze raz</p>
    
    </div>
    <CustomButtons clickFunction={reset} classButton="solid" size="big">SPRÓBUJ PONOWNIE</CustomButtons>
    
    
    
    </div>:""
}  
      {
    msg == "error_przypominanie_hasla"?
    <div className='remiandPasswordSuccessMsg_area'>
    <CustomRedText>Wystąpił problem</CustomRedText>
    <div className='msg_area'>
    <p className='msg msgIn'>Nie udało się wysłać linku zmieniającego hasło na wskazany adres E-mail</p>
    <CustomButtons clickFunction={reset} classButton="solid" size="big">SPRÓBUJ PONOWNIE</CustomButtons>
    </div>
   
    
    
    
    </div>:""
}         
    {
    msg == "odzyskaj_konto_wyslane"?
    <div className='remiandPasswordSuccessMsg_area'>
    <CustomTittle>Sprawdź swoją skrzynkę mailową</CustomTittle>
    <div className='msg_area'>
    <p className='msg msgIn'>Na adres</p>
    <CustomRedText>{formData.login}</CustomRedText>
    </div>
    <p className='msg msgOut'>wysłaliśmy wiadomość zawierającą link do aktywacji hasła. Postępuj zgodnie z instrukcjami zawartymi w mailu.
    </p>
    
    
    
    </div>:""
}
  {
    msg == "strAnotherUserWithEmailOrPesel"?
    <div className='remiandPasswordSuccessMsg_area'>
    <CustomTittle>Użytkownik z takim Peslem już istnieje</CustomTittle>
    <div className='msg_area'>
    <p className='msg msgIn'>Skontaktuj się z recepcją</p>
    </div>   
    
    </div>:""
}
{
    msg == ""?<div className='remiandPassword_area'>
    <CustomTittle>Nie pamiętasz swojego hasła?</CustomTittle>
    <p className="emailTitle">Podaj swój adres e-mail</p>
    <CustomInput onChangeInput={(e) => {setFromData({...formData, ...{ login: e },})}} isRequied={true} title="E-mail"></CustomInput>
    <CustomButtons clickFunction={save} classButton="solid" size="big">WYŚLIJ</CustomButtons>
    </div>:""
    }</>;
    
    };

export default RemiandPassword;
